<script lang="ts" setup>
import { useApiStore, type LaudMarker } from "@/stores/api";
import { ref, Ref } from "vue";

const apiStore = useApiStore();
const markers: Ref<Array<{ position: { lat: number; lng: number } }>> = ref([]);
const openedMarkerID: Ref<null | number> = ref(null);

apiStore.getMarkers().then(
    (m) =>
        (markers.value = m.map((lm) => {
            return { meta: lm, position: { lat: lm.lat, lng: lm.lng } };
        })),
);

const center = ref({ lat: 50.9382842, lng: 5.3371564 });
const offices = [
    {
        position: {
            lat: 50.938154,
            lng: 5.337717,
        },
    },
];

const options = {
    streetViewControl: false,
    draggingCursor: false,
    zoomControl: true,
    mapTypeControl: false,
    fullscreenControl: false,
    keyboardShortcuts: false,
    styles: [
        {
            featureType: "poi",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "road",
            elementType: "labels",
            stylers: [
                {
                    visibility: "off",
                },
            ],
        },
        {
            featureType: "all",
            elementType: "all",
            stylers: [{ saturation: -150 }],
        },
    ],
};

const openMarker = (id: number | null, m?: { position: { lat: number; lng: number } } | null) => {
    openedMarkerID.value = id;
    if (m) {
        center.value = m.position;
    }
};
</script>

<template>
    <GMapMap class="w-full" :center="center" :zoom="13" style="height: 572px" :disableDefaultUI="true" :options="options">
        <GMapMarker :key="index" v-for="(m, index) in offices" :position="m.position" icon="/hoofdlocatie.svg" :clickable="false" :draggable="false" @click="center = m.position" />
        <GMapMarker :key="index" v-for="(m, index) in markers" :position="m.position" icon="/locatie.svg" :clickable="true" :draggable="false" @click="openMarker(index, m)">
            <GMapInfoWindow :opened="openedMarkerID === index" @closeclick="openMarker(null)">
                <div class="min-w-[300px] flex flex-row gap-[20px] items-start p-[16px]">
                    <div class="flex flex-col gap-[16px] items-start">
                        <div class="laud-underline xxs mb-[10px]" v-html="m.meta.title"></div>
                        <div class="prose" v-html="m.meta.intro"></div>
                        <a :href="m.meta.relative_link" :data-project-readmore="m.meta.post_title" class="btn btn-brown-200 cta flex flex-row items-center gap-8 cta-project-readmore">Bekijk project</a>
                    </div>
                </div>
            </GMapInfoWindow>
        </GMapMarker>
    </GMapMap>
</template>

<style>
.gm-style-iw.gm-style-iw-c {
    max-width: calc(100vw - 32px) !important;
}
.gm-ui-hover-effect {
    width: 40px !important;
    height: 40px !important;
    top: 0px !important;
    right: 0px !important;
    margin: auto !important;
}
.gm-ui-hover-effect span {
    width: 20px !important;
    height: 20px !important;
    margin: auto !important;
}
</style>
